import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiScissors,FiStar,FiClock,FiDollarSign}=FiIcons;

function Services() {
  const services=[
    {name: 'Classic Haircut',description: 'Traditional barbering techniques for a timeless,professional look.',price: '$35',duration: '45 min',image: 'https://i.ibb.co/QFW6zk7Z/images-2.jpg'},
    {name: 'Beard Trim & Shape',description: 'Expert beard trimming and shaping to complement your facial structure.',price: '$25',duration: '30 min',image: 'https://i.ibb.co/0Vc6tgzx/images-3.jpg'},
    {name: 'Hot Towel Shave',description: 'Luxurious traditional straight razor shave with hot towel treatment.',price: '$45',duration: '60 min',image: 'https://i.ibb.co/23t9zDr8/images-4.jpg'},
    {name: 'Hair Wash & Style',description: 'Complete hair washing and professional styling service.',price: '$20',duration: '30 min',image: 'https://i.ibb.co/ZzHbcGkQ/images-5.jpg'},
    {name: 'Mustache Grooming',description: 'Precision mustache trimming and styling for the perfect look.',price: '$15',duration: '20 min',image: 'https://i.ibb.co/7x6r8tQN/images-6.jpg'},
    {name: 'Complete Grooming Package',description: 'Full service including haircut,beard trim,and hot towel shave.',price: '$85',duration: '90 min',image: 'https://i.ibb.co/zhZNn0gv/images-7.jpg'}
  ];

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} transition={{duration: 0.5}} className="flex-1" >
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" >
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Services</span>
          </motion.h1>
          <motion.p initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.4,duration: 0.8}} className="text-xl text-gray-400 max-w-2xl mx-auto" >
            Experience premium barbering services crafted with precision and care
          </motion.p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service,index)=> (
              <motion.div key={index} initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: index * 0.1,duration: 0.8}} viewport={{once: true}} className="bg-black rounded-lg overflow-hidden border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300 hover:transform hover:scale-105 group" >
                <div className="relative h-48 overflow-hidden">
                  <img src={service.image} alt={service.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{service.name}</h3>
                  <p className="text-gray-400 mb-4 leading-relaxed">{service.description}</p>
                  <div className="flex justify-between items-center mb-4">
                    <div className="flex items-center">
                      <SafeIcon icon={FiDollarSign} className="h-4 w-4 text-yellow-400 mr-1" />
                      <span className="text-yellow-400 font-semibold">{service.price}</span>
                    </div>
                    <div className="flex items-center">
                      <SafeIcon icon={FiClock} className="h-4 w-4 text-gray-400 mr-1" />
                      <span className="text-gray-400 text-sm">{service.duration}</span>
                    </div>
                  </div>
                  <a href="tel:+14166379929" className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-black py-2 px-4 rounded-lg font-semibold text-center block hover:shadow-lg transition-all duration-300" >
                    Book Now
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2 initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="text-3xl sm:text-4xl font-bold text-white mb-6" >
            Ready for a Fresh Look?
          </motion.h2>
          <motion.p initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} viewport={{once: true}} className="text-xl text-gray-400 mb-8" >
            Book your appointment today and experience the West End Barbers difference
          </motion.p>
          <motion.a initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: 0.4,duration: 0.8}} viewport={{once: true}} href="tel:+14166379929" className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-black px-8 py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300" >
            Call +1 (416) 637-9929
          </motion.a>
        </div>
      </section>
    </motion.div>
  );
}

export default Services;